import { Link } from 'react-router-dom';
import { FadeUp } from '../motion';
import { useT } from '../../i18n/LangContext';
import { useContent } from '../../data/useContent';

export default function TileGrid() {
  const t = useT();
  const { TILES } = useContent();

  return (
    <section data-testid="tile-grid-section" className="bg-ink py-24 md:py-32">
      <div className="container-site">
        <FadeUp className="text-center">
          <h2 className="font-serif text-4xl font-semibold leading-tight tracking-tight sm:text-5xl">
            {t['tg.h2a']} <span className="italic text-gold">{t['tg.h2b']}</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-silver">{t['tg.p']}</p>
        </FadeUp>

        <div className="mt-14 grid grid-cols-2 gap-4 md:gap-6 lg:grid-cols-4">
          {TILES.map((tile, i) => (
            <FadeUp key={tile.slug + tile.label} delay={(i % 4) * 0.06}>
              <Link data-testid={`tile-${tile.slug}`} to={`/gallery?space=${tile.slug}`}
                className="group relative block overflow-hidden rounded-xl shadow-lg transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-2xl">
                <img src={tile.img} alt={`${tile.label} — Reverence Services, Ottawa`} loading="lazy"
                  className="photo-treat aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute left-0 right-0 top-1/2 -translate-y-1/2 bg-black/55 py-3 text-center backdrop-blur-[2px] transition-colors duration-500 group-hover:bg-black/75">
                  <span className="text-sm font-bold tracking-wide text-white md:text-base">{tile.label}</span>
                </div>
              </Link>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
